import React, { useState } from "react";


const FloatingButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}

      style={{
        position: "fixed",
        bottom: "120px",
        right: "24px",
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        backgroundColor: isHovered ? "#128C7E" : "#25D366",  // hover color
        color: "white",
        fontSize: "32px",
        border: "none",
        cursor: "pointer",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
        transition: "background 0.2s ease, transform 0.1s ease",
        transform: isHovered ? "scale(1.05)" : "scale(1)", // hover scale
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2147483647
      }} className="wfab fab fa-whatsapp" onClick={() => window.open("https://wa.me/254745715136", "_blank")}>

    </button>
  );
};

export default FloatingButton;
